import React from 'react';

import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { Apollo } from 'src/gql/generated';
import { openLink } from 'src/helpers';
import { alineLinkButtonStylesWithUnderline } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  text: {
    ...alineLinkButtonStylesWithUnderline,
  },
}));

interface DocumentLicenseRow {
  license: Pick<Apollo.SupportedLicense, 'id' | 'name' | 'url' | '__typename'> | null;
}

export function DocumentLicenseCell({
  row: { license },
}: GridCellParams<DocumentLicenseRow>): JSX.Element {
  const { classes } = useStyles();

  if (!license) return <>-</>;

  return (
    <Typography className={classes.text} onClick={() => openLink(license.url)}>
      {license.name}
    </Typography>
  );
}
